(() => {
  const UTILS = {
    ObserveIntersection(node, config, callback) {
      if (!node) callback(null);
      let observer = new IntersectionObserver((entries) => {
        callback(entries);
      }, config);
      
      observer.observe(node, config);  
      return observer;
    }  
  };

  document.addEventListener('alpine:init', () => {
    Alpine.data('VideoSwiper', () => ({
      init() {
        this.InitSelf()
      },
      InitSelf() {
        let am = this;
        UTILS.ObserveIntersection(am.$el, {}, (entries) => {
          if (entries.length) {
            am.$el.querySelectorAll('video').forEach(($video) => {
              $video[entries[0].isIntersecting ? 'play' : 'pause']()
              // console.log($video.paused)
            })
          }
        })
      }
    }));

    Alpine.data('VideoMp4', () => ({
      flags: {
        paused: true
      },
      cache: {},
      init() {
        this.InitCache();
        this.InitSelf();
        this.InitEventHandlers();
      },
      InitSelf() {
        let am = this;
        am.cache.$video.poster = am.cache.$video.poster.replace('_small', '');
        UTILS.ObserveIntersection(am.cache.$video, {}, (entries) => {
          let entry = entries[0];
          if (!entry.isIntersecting) {
            am.cache.$video.pause();
          }
        });
      },
      InitCache() {
        let am = this;
        am.cache.$video = am.$el.querySelector('video');
      },
      InitEventHandlers() {
        let am = this;
        am.cache.$video.addEventListener('pause', () => {
          am.flags.paused = true;
        });
        am.cache.$video.addEventListener('play', () => {
          am.flags.paused = false;
        });
      },
      e_ToggleVideoPlay() {
        let am = this;
        am.flags.paused = !am.flags.paused;
        am.cache.$video[am.flags.paused ? 'pause' : 'play']();
        am.cache.$video.controls = !am.flags.paused;
      }
    }));
  })
})()